module.exports = __webpack_public_path__ + "img/Ma.Maritime.Suspendeddeck.Suspendeddeck-18m.Concrete.380d1660.png";